// Este archivo es generado automáticamente durante el pipeline.
export const environment = {
  production: false,
  apiUrl: "https://silabvet-dev.senasa.gob.hn/api",

  buildInformation: {
    version: "dev-1228fc41",
    commit: "1228fc41ad56eb638897d5b32722ce94fda4a1a1",
    branch: "deployDev",
    buildDate: "2026-10-21T14:44:15.306Z",
  },
} as const;
